import React, { useState } from 'react';
import './ValueTiles.css';

// Default values data with icons, colors, and descriptions (from About page)
const defaultValues = [
  {
    id: 'kindness',
    title: 'Kindness',
    icon: 'bi-heart',
    gradient: 'linear-gradient(135deg, #C4A5A0, #B8A898)',
    description: 'We approach every interaction with kindness - towards yourself, others, your dance journey, and every dancer\'s story.'
  },
  {
    id: 'curiosity',
    title: 'Curiosity',
    icon: 'bi-lightbulb',
    gradient: 'linear-gradient(135deg, #C5CBA3, #D4DBA8)',
    description: 'A willingness to learn from others, question assumptions, and move beyond ego. Every dancer has something to teach us.'
  },
  {
    id: 'respect',
    title: 'Respect',
    icon: 'bi-shield-check',
    gradient: 'linear-gradient(135deg, #B8A898, #C4A5A0)',
    description: 'We believe in honest, thoughtful feedback that uplifts rather than harms. Every voice matters in our community.'
  },
  {
    id: 'awareness',
    title: 'Awareness',
    icon: 'bi-eye',
    gradient: 'linear-gradient(135deg, #D8C8E8, #C4A5A0)',
    description: 'Knowing where you stand is where conscious movement begins. We encourage reflection and self-understanding.'
  },
  {
    id: 'empowerment',
    title: 'Empowerment',
    icon: 'bi-rocket-takeoff',
    gradient: 'linear-gradient(135deg, #C4A5A0, #D8C8E8)',
    description: 'Empowering dancers to reflect, speak, and move with intention. Your voice and choices matter.'
  },
  {
    id: 'community',
    title: 'Community',
    icon: 'bi-people',
    gradient: 'linear-gradient(135deg, #C5CBA3, #B8A898)',
    description: 'Together we build a culture of support and mutual care. We\'re stronger when we dance together.'
  }
];

const ValueTiles = ({
  values = defaultValues,
  variant = 'default',
  showIcons = true,
  className = ''
}) => {
  const [selectedValue, setSelectedValue] = useState(null);

  const handleValueClick = (value) => {
    setSelectedValue(value);
  };

  const closeModal = () => {
    setSelectedValue(null);
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('value-modal-backdrop')) {
      closeModal();
    }
  };

  return (
    <>
      <div className={`value-tiles-grid ${variant} ${className}`}>
        {values.map((value, index) => (
          <div
            key={value.id || index}
            className="value-tile"
            onClick={() => handleValueClick(value)}
          >
            {showIcons && (
              <div
                className="value-tile-icon"
                style={{ background: value.gradient }}
              >
                <i className={`bi ${value.icon}`}></i>
              </div>
            )}
            <h3 className="value-tile-title">{value.title}</h3>
          </div>
        ))}
      </div>

      {/* Value Description Modal */}
      {selectedValue && (
        <div className="value-modal-backdrop" onClick={handleBackdropClick}>
          <div className="value-modal">
            <button className="value-modal-close" onClick={closeModal}>
              <i className="bi bi-x-lg"></i>
            </button>
            <div
              className="value-modal-icon"
              style={{ background: selectedValue.gradient }}
            >
              <i className={`bi ${selectedValue.icon}`}></i>
            </div>
            <h3 className="value-modal-title">{selectedValue.title}</h3>
            <p className="value-modal-description">{selectedValue.description}</p>
            <button className="value-modal-btn" onClick={closeModal}>
              Got it!
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ValueTiles;
